document.addEventListener("DOMContentLoaded", () => {
  const configurator3D = document.getElementById("gallery-3d-window");
  const configuratorLoader = $('.desktronic_3d_loader');
  const optionLabels = document.querySelectorAll(
    ".single-option-selector__radio + label"
  );
  const optionInputs = document.querySelectorAll(
    ".single-option-selector__radio"
  );
  const mimeeqOpener = document.querySelector("[is-3d-opener]");
  const addoneList = document.querySelector(".product-single__add-ons__wrap");

  mimeeqOpener.addEventListener("click", (event) => {
    event.stopPropagation();
    if (mimeeqOpener.classList.contains('preloading')) {
      console.log('not clickable')
    }
    else{ 
      if (window.mmqShowed == true) {
        // console.log('mmq is loaded');
        configurator3D.classList.add('open');
        $('.product-3d-window').css('display', 'flex');
      } 
      else{

        $('.desktronic_loader3d_out').addClass('active');
        $('.loader.desktronic_loader_2step').show();
    
        const mmqInterval = setInterval(async () => {
          if (window.mmqLoaded && window.mmqSelectingNow == false) {
              // console.log('mmq loaded');
              
              clearInterval(mmqInterval);
  
              setTimeout(function(){
                configurator3D.classList.add('open');
                $('.product-3d-window').css('display', 'flex');
                $('.desktronic_loader3d_out').addClass('active2nd');
                $('.loader.desktronic_loader_2step').hide();
                $('.loader.desktronic_loader_3step').show();
              },1800);

              setTimeout(function(){
                  $('.loader.desktronic_loader_2step').hide();
                  $('.loader.desktronic_loader_3step').hide();
                  $('.desktronic_loader3d_out').removeClass('active2nd');
                  $('.desktronic_loader3d_out').removeClass('active');
              },3500);
    
            window.mmqShowed = true;
          } 
        }, 200);
      }
    }      
  }); 

  var preselectCompleted = 0;
  window.mmqSelectingNow = false;
  $('.product__option-wraper .swiper-slide').click(function (){
    selectMainImage();
    const mmqBlock = $(this).find('input').attr("data-mmq-block");
    const mmqCode = $(this).find('input').attr("data-mmq-code");

    addoneList ? addoneList.classList.add("preload") : '';
    $('.opener-3D').addClass('preloading');

    if (window.mmqLoaded) {
      addoneList ? addoneList.classList.remove("preload") : '';
      $('.opener-3D').removeClass('preloading');
      if (window.mmqSelectingNow  == true){
        var intervalCheckId = setInterval(function(){
          if (window.mmqSelectingNow  == false){
            clearInterval(intervalCheckId);
            window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
              mmqBlock,
              mmqCode
            );
          }
        },200);
      }
      else{
        window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
          mmqBlock,
          mmqCode
        );
      }
    }
    else{
      var intervalId = setInterval(function(){
        if (window.mmqLoaded) {
          clearInterval(intervalId);
          if (preselectCompleted == 0){
            preselectCompleted = 1;
            
            // console.log('PRESELECT NOW ONLY');
            window.mmqSelectingNow = true;
            $('.product__option-wraper .swiper-slide input:checked').each(function (index){
              const mmqBlock = $(this).attr("data-mmq-block");
              const mmqCode = $(this).attr("data-mmq-code");

              if(typeof mmqBlock != 'undefined' || typeof mmqCode != 'undefined'){
                setTimeout(function(){
                  window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
                    mmqBlock,
                    mmqCode
                  );
                  // console.log("mmq changed actually", mmqBlock, mmqCode);
                }, index * 500);
              }
              
            });

            setTimeout(function(){
              $('.opener-3D').removeClass('preloading');
              addoneList ? addoneList.classList.remove("preload") : '';
              window.mmqSelectingNow = false;
            },1500);
            
            // preselectCompleted = 0;
          }
        }
        else{
          // console.log("mmq not loaded yet");
        }
      },200);
    }

    window.pdpSwiper.slideTo(0);

    if (window.mmqShowed) {
      document.getElementById('gallery-3d-window').classList.add('open');
    }

  });

  function selectMainImage(){
    console.log('Setting image source');
    var fullTitle = '';
    $('.single-option-selector__radio:checked').each(function (index){
      fullTitle = fullTitle + $(this).attr('data-value') + '-';
    });

    fullTitle = fullTitle.slice(0, -1);
    console.log('fullTitle', fullTitle);
    var imageSource = $('.pp_config__js[data-title="'+fullTitle+'"]').attr('data-variant-src');
    console.log('imageSource', imageSource);
    $('#product-variant__src').attr('src', imageSource);
    $('#product-variant__thumb').attr('src', imageSource);
    console.log('CHANGED !');
  }


  const checkedOptionInputs = document.querySelectorAll(
    ".single-option-selector__radio:checked"
  );

  document.addEventListener("mimeeq-app-loaded", () => {
    let count = 0;

    setTimeout(() => {
      checkedOptionInputs.forEach((input, inputIdx) => {
        const mmqBlock = input.getAttribute("data-mmq-block");
        const mmqCode = input.getAttribute("data-mmq-code");
        console.log("mmq change 2", mmqBlock, mmqCode);

        setTimeout(async () => {
          await window.mimeeqApp.actions.markOptionByBlockNameAndOptionCode(
            mmqBlock,
            mmqCode
          );

          count++;
          if (count === checkedOptionInputs.length) {
            setTimeout(() => {
              window.mmqLoaded = true;
            }, 1000);
          }
        }, 1200 * (inputIdx + 1));
      });
    }, 3000);
  });
});
